import { createElement, IntersectionObserver } from "./utils/dom";

// ----------------------------------------------------------------------------

function seekVideo(video, time) {
  return new Promise((resolve) => {
    if (video.currentTime === time) {
      resolve(time);
    } else {
      video.addEventListener("seeked", () => resolve(time), {
        once: true,
        passive: true,
      });
      video.currentTime = time;
    }
  });
}

function playWhenVisible(video, minRatio) {
  return ({ intersectionRatio }) => {
    if (intersectionRatio <= minRatio) {
      video.pause();
    } else if (video.ended === false) {
      video
        .play()
        .then(() => {})
        .catch((error) => {
          let className = "play-button";
          if (video.className.includes("desktop")) {
            className = "plato-button-desktop";
          } else if (video.className.includes("mobile")) {
            className = "plato-button-mobile";
          }
          if (video.parentNode.querySelector("." + className) === null) {
            className =
              className === "play-button"
                ? className
                : "play-button " + className;
            var playBtn = createElement("div", {
              className,
              children: [createElement("span", { text: "▶︎" })],
            });

            playBtn.addEventListener(
              "click",
              () => {
                seekVideo(video, 0).then(() => {
                  playBtn.remove();
                  video.play();
                });
              },
              { once: true }
            );

            video.parentNode.appendChild(playBtn);
          }
        });
    }
  };
}

function syncToScroll(video) {
  let prevTime = null;

  const syncVideoFrame = function (e) {
    if (e === undefined) {
      video
        .play()
        .then(() => {
          video.pause();
        })
        .catch((error) => {
          let className = "play-button";
          if (video.className.includes("desktop")) {
            className = "plato-button-desktop";
          } else if (video.className.includes("mobile")) {
            className = "plato-button-mobile";
          }
          if (video.parentNode.querySelector("." + className) === null) {
            className =
              className === "play-button"
                ? className
                : "play-button " + className;
            var playBtn = createElement("div", {
              className,
              children: [createElement("span", { text: "▶︎" })],
            });

            playBtn.addEventListener(
              "click",
              () => {
                playBtn.remove();
                video.play().then(() => {
                  video.pause();
                });
              },
              { once: true }
            );

            video.parentNode.appendChild(playBtn);
          }
        });
    }
    var dims = video.getBoundingClientRect();
    var p =
      (window.innerHeight - dims.top) / (window.innerHeight + dims.height);
    var time = (p * video.duration).toFixed(2);
    if (time !== prevTime && time !== "NaN") {
      video.currentTime = time;
    }
  };

  return ({ intersectionRatio }) => {
    if (intersectionRatio <= 0) {
      window.removeEventListener("scroll", syncVideoFrame);
    } else {
      window.addEventListener("scroll", syncVideoFrame, { passive: true });
      syncVideoFrame();
    }
  };
}

// ----------------------------------------------------------------------------

export function initPlatoVideos(
  platoVideoClassName = "plato-video",
  autoplayThreshold = 0.33
) {
  var videos = Array.prototype.slice.call(
    document.getElementsByClassName(platoVideoClassName),
    0
  );

  if (videos.length === 0) {
    return;
  }

  var io = new IntersectionObserver({
    threshold: [
      autoplayThreshold,
      0, // Sync to scroll
    ],
  });

  videos.forEach((video) => {
    if (video.dataset.mode === "autoplay") {
      video.playsinline = true;
      video.muted = true;
      video.controls = false;

      io.observe(video, playWhenVisible(video, autoplayThreshold));
    } else if (video.dataset.mode === "theater") {
      video.muted = true;
      video.controls = false;
      video.currentTime = parseInt(video.dataset.tt) || 0;

      let className = "play-button";
      if (video.className.includes("desktop")) {
        className += " plato-button-desktop";
      } else if (video.className.includes("mobile")) {
        className += " plato-button-mobile";
        video
          .play()
          .then(() => {
            video.pause();
            video.currentTime = parseInt(video.dataset.tt) || 0;
          })
          .catch((error) => {});
      }

      var playBtn = createElement("div", {
        className: className,
        children: [createElement("span", { text: "▶︎" })],
      });

      playBtn.addEventListener(
        "click",
        () => {
          playBtn.remove();
          try {
            video.removeAttribute("playsinline");
            video.currentTime = 0;
            video.controls = true;
            video.muted = false;
            video.play();
          } catch (error) {
            console.log("Can't Play Video");
          }
        },
        { once: true }
      );

      video.parentNode.appendChild(playBtn);
    } else if (video.dataset.mode === "scroll") {
      video.playsinline = true;
      video.muted = true;
      video.controls = false;
      video.pause();
      io.observe(video, syncToScroll(video));
    }
  });
}
